import React from 'react';
import PropTypes from 'prop-types';
import "../style.css";

/**
 * Reusable volume slider component
 * 
 * @param {string} label - The label for the slider
 * @param {number} value - Current value of the slider
 * @param {function} onChange - Function to call when slider value changes
 * @param {boolean} hasResetButton - Whether to show a reset button
 * @param {function} onReset - Function to call when reset button is clicked
 * @param {function} valueFormatter - Function to format the displayed value
 */
const VolumeSlider = ({ 
  label, 
  value, 
  onChange, 
  hasResetButton = false, 
  onReset = null, 
  valueFormatter = (val) => val
}) => {
    const sliderId = `slider-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;

    return (
        <div className={hasResetButton ? "slider-with-reset" : "slider-container"}>
            <div className="slider-label-container">
            <label className="slider-label" htmlFor={sliderId}>{label}</label>
            <span className="slider-value">{valueFormatter(value)}</span>
            </div>

            <div className={hasResetButton ? "slider-controls" : ""}>
            <input
                id={sliderId}
                type="range"
                min="0"
                max="100"
                step="1"
                value={value}
                onChange={(e) => onChange(parseInt(e.target.value))}
                className="slider"
            />
            {hasResetButton && (
                <button onClick={onReset} className="reset-button">Reset</button>
            )}
            </div>
        </div>
        );
};

VolumeSlider.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  hasResetButton: PropTypes.bool,
  onReset: PropTypes.func,
  valueFormatter: PropTypes.func
};

export default VolumeSlider;